import { render, staticRenderFns } from "./ModalExtendDays.vue?vue&type=template&id=3fa70b39&"
import script from "./ModalExtendDays.vue?vue&type=script&lang=js&"
export * from "./ModalExtendDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports